<template>
  <vs-row vs-type="flex" vs-w="12" id="productCategoryPage">
    <new-category-add ref="newCategoryAdd" @saveChanges="saveNewCategory" />
    <new-product-add-to-category ref="newProductAddToCategory" @saveChanges="saveNewProduct" />
    <vs-popup class="holamundo" title="Kategori Sil" v-esc="escapeDeleteCategory" :active.sync="deleteCategoryActive">
      <vs-row vs-type="flex" vs-w="12" v-if="toRemoveCategory != null">
        <span>{{toRemoveCategory.name}} Kategorisini Silmek İstediğinize Eminmisiniz ? </span>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="deleteCategoryActive = false;">Vazgeç
        </vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash"
          @click="toRemoveCategory.rootCategoryId == null ? removeCategory(true) : removeCategory(false)">
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-popup class="holamundo" title="Ürün Sil" v-show="deleteProductPopupActive && selectedProducts.length > 0"
      v-esc="escapeDeleteProducts" :active.sync="deleteProductPopupActive">
      <vs-row vs-type="flex" vs-w="12">
        <span>Seçili Ürünleri({{selectedProducts.length}}) Çıkarmak İstediğinize Eminmisiniz ? </span>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button type="gradient" color="primary" @click="deleteProductPopupActive = false;">Vazgeç
        </vs-button>
        <vs-button type="gradient" color="danger" icon-pack="feather" icon="icon-trash" @click="deleteListFromCategory">
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>

    <vs-row vs-type="flex" vs-w="12" id="categoryList">
      <vs-row vs-type="flex" vs-w="12" vs-justify="space-between" vs-align="center" class="mb-4">
        <vs-col vs-type="flex" class="w-auto" vs-align="center">
          <vs-button :disabled="categoryBreadCrumbs.length == 0" @click="getBackCategory" icon-pack="feather"
            icon="icon-arrow-left" color="primary" class="mr-3" />
          <span class="d-flex w-auto bg-white py-2 px-4 sale-box-shadow low-border-radius">
            <span class="text-small passiveCategory pointer" @click="clearBreadCrumb">Kategoriler</span>
            <template v-for="(breadCrumb,index) in categoryBreadCrumbs">
              <span :key="'sep'+breadCrumb.id" class="mx-2 text-medium-small passiveCategory">-</span>
              <span :key="breadCrumb.id" class="text-small activeCategory">{{breadCrumb.name}}</span>
            </template>
          </span>
        </vs-col>
        <vs-col vs-type="flex" class="w-auto">
          <vx-tooltip v-if="$isCenterBranch() && isAddProductCategoryPermission"
            :text="(categoryBreadCrumbs.length > 0 ? categoryBreadCrumbs[categoryBreadCrumbs.length-1].name : 'Ana') + ' Kategoriye Alt Kategori Ekle'"
            position="top">
            <vs-button
              @click="categoryBreadCrumbs.length > 0 ? addNewSubCategory(categoryBreadCrumbs[categoryBreadCrumbs.length-1]) : addNewCategory()"
              class="panel-action text-success large-button panel-action-box-shadow" color="transparent"
              icon-pack="feather" icon="icon-plus">
            </vs-button>
          </vx-tooltip>
        </vs-col>
      </vs-row>

      <vs-row vs-type="flex" vs-w="12" v-if="categoryDataList == null" vs-justify="center" class="mt-2 mb-4">
        <span class="text-secondary text-small weight-600">Hiçbir Kategori Bulunmamaktadır !</span>
      </vs-row>

      <vs-table v-else id="categoryTable" v-model="selectedCategoryRow" :data="categoryDataList" class="w-full mb-4">
        <template slot="thead">
          <vs-th style="width: 80px;"></vs-th>
          <vs-th>Kategori Adı</vs-th>
          <vs-th style="width: 320px;">İşlem</vs-th>
        </template>
        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="category" :key="category.id" v-for="category in data" class="cursor-pointer"
              :title="$isCenterBranch() ? 'Tıklayarak düzenleyin' : 'Tıklayarak içeriğini görüntüleyin'">
              <vs-td>
                <img class="categoryRowImage" :src="getImage(category.imageUrl)" />
              </vs-td>
              <vs-td>
                <span class="weight-600">{{category.name}}</span>
              </vs-td>
              <vs-td class="whitespace-no-wrap">
                <feather-icon icon="PackageIcon" title="Alt Kategori / Ürünler"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-1 mr-1"
                  @click.stop="selectCategory(category)" />
                <feather-icon v-if="$isCenterBranch() && isDeleteProductCategoryPermission" icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-1"
                  @click.stop="toRemoveCategory = category; deleteCategoryActive = true;" />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </vs-row>

    <vs-popup class="holamundo productListPopup" :title="selectedCategory ? (selectedCategory.name + ' — Ürünler') : 'Ürünler'"
      :active="selectedCategory != null" @update:active="val => { if (!val) selectedCategory = null; }">
      <vs-row vs-type="flex" vs-w="12" id="productList" v-if="selectedCategory != null">
        <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" vs-align="center" class="mb-4">
          <vx-tooltip v-if="$isCenterBranch()" text="Ürün Ata" position="top" class="mr-2">
            <vs-button @click="addNewProduct" class="panel-action text-success large-button panel-action-box-shadow"
              color="transparent" icon-pack="feather" icon="icon-plus">
            </vs-button>
          </vx-tooltip>
          <vx-tooltip v-if="this.selectedProducts.length > 0 && $isCenterBranch()" text="Seçilenleri Kategoriden Çıkar" position="top">
            <vs-button @click="deleteProductPopupActive = true;"
              class="panel-action text-danger large-button panel-action-box-shadow" color="transparent"
              icon-pack="feather" icon="icon-minus">
            </vs-button>
          </vx-tooltip>
        </vs-row>

        <vs-row vs-type="flex" vs-w="12" v-if="productDataList == null" vs-justify="center" class="mb-4">
          <span class="text-secondary text-small weight-600">Bu Kategoride Ürün Bulunmamaktadır !</span>
        </vs-row>

        <vs-table v-else id="productTable" v-model="selectedProductRow" :data="productDataList" class="w-full">
          <template slot="thead">
            <vs-th style="width: 80px;"></vs-th>
            <vs-th>Ürün Adı</vs-th>
            <vs-th style="width: 80px;">Seç</vs-th>
          </template>
          <template slot-scope="{ data }">
            <tbody>
              <vs-tr :data="product" :key="product.id" v-for="product in data" class="cursor-pointer"
                :class="{ 'selected-row': isSelectedProduct(product.id) }">
                <vs-td>
                  <img class="categoryRowImage" :src="getImage(product.imageUrl)" />
                </vs-td>
                <vs-td>
                  <span class="weight-600">{{product.name}}</span>
                </vs-td>
                <vs-td>
                  <feather-icon v-if="isSelectedProduct(product.id)" icon='CheckCircleIcon' svgClasses='text-primary w-6 h-6' />
                </vs-td>
              </vs-tr>
            </tbody>
          </template>
        </vs-table>
      </vs-row>
    </vs-popup>
  </vs-row>
</template>

<script>
  import NewProductAddToCategory from "./NewProductAddToCategory.vue";
  import NewCategoryAdd from "./NewCategoryAdd.vue";
  import {
    getProductCategories,
    getCategoryDetail,
    deleteListFromCategory,
    deleteProductCategory
  } from "@/api/ProductCategory";
  import {isGranted} from "@/utils/auth";
  export default {
    data() {
      return {
        categories: null,
        selectedCategory: null,
        selectedProducts: [],
        categoryBreadCrumbs: [],
        deleteProductPopupActive: false,
        toRemoveCategory: null,
        deleteCategoryActive: null,
        selectedCategoryRow: "",
        selectedProductRow: ""
      }
    },
    components: {
      NewCategoryAdd,
      NewProductAddToCategory
    },
    watch: {
      selectedCategoryRow(val) {
        if (val) {
          if (this.$isCenterBranch()) this.editCategory(val);
          else this.selectCategory(val);
          this.selectedCategoryRow = "";
        }
      },
      selectedProductRow(val) {
        if (val) {
          this.productClicked(val.id);
          this.selectedProductRow = "";
        }
      }
    },
    computed: {
      categoryDataList() {
        let list = this.categoryBreadCrumbs.length > 0 ? this.categoryBreadCrumbs[this.categoryBreadCrumbs.length - 1]
          .childCategories : this.categories;
        return (list == null || list.length === 0) ? null : list;
      },
      productDataList() {
        let list = this.selectedCategory.products;
        return (list == null || list.length === 0) ? null : list;
      },
      isAddProductCategoryPermission(){
        return isGranted("product_category_write")
      },
      isDeleteProductCategoryPermission(){
        return isGranted("product_category_delete")
      }
    },
    methods: {
      saveNewProduct(){
        this.getCategoryDetail(this.selectedCategory);
      },
      getBackCategory() {
        this.selectedCategory = null;
        this.categoryBreadCrumbs.splice(-1)
      },
      deleteListFromCategory() {
        if (this.selectedProducts.length <= 0) return;
        let obj = {
          categoryId: this.selectedCategory.id,
          productsIds: this.selectedProducts
        };
        deleteListFromCategory(obj).then(res => {
          if (res && res.status == 200) {
            this.selectedProducts.forEach(removed => {
              let index = this.selectedCategory.products.findIndex(x => x.id == removed);
              this.selectedCategory.products.splice(index, 1);
            });
            this.selectedProducts = [];
            this.deleteProductPopupActive = false;
            this.$vs.notify({
              color: 'success',
              title: 'Başarılı ! ',
              text: 'Seçilen Ürünler Çıkartıldı !'
            });
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Seçilen Ürünler Çıkartılamadı !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      escapeDeleteCategory() {
        if (this.deleteCategoryActive == true) this.deleteCategoryActive = false;
      },
      escapeDeleteProducts() {
        if (this.deleteProductPopupActive == true) {
          this.deleteProductPopupActive = false;
          this.selectedProducts = [];
        }
      },
      goInsideCategory(category) {
        this.categoryBreadCrumbs.push(category);
        this.selectedCategory = null;
      },
      productClicked(id) {
        let selected = this.selectedProducts.findIndex(x => x == id);
        if (selected >= 0) this.selectedProducts.splice(selected, 1);
        else this.selectedProducts.push(id);
      },
      isSelectedProduct(id) {
        return this.selectedProducts.some(x => x == id);
      },
      clearBreadCrumb() {
        this.categoryBreadCrumbs = [];
        this.selectedCategory = null;
      },
      selectCategory(category) {
        this.getCategoryDetail(category);
      },
      editCategory(category) {
        if (this.categoryBreadCrumbs.length > 1) {
          let root = this.categoryBreadCrumbs[this.categoryBreadCrumbs.length - 2];
          this.$refs.newCategoryAdd.rootCategory = {
            id: root.id,
            name: root.name,
            childCategories: _.cloneDeep(root.childCategories)
          }
        } else {
          let root = this.categories;
          this.$refs.newCategoryAdd.rootCategory = {
            id: 0,
            name: "Ana Kategori",
            childCategories: _.cloneDeep(root)
          }
        }
        this.$refs.newCategoryAdd.isActive = true;
        this.$refs.newCategoryAdd.newCategory = category;
        let oldIndex = this.$refs.newCategoryAdd.rootCategory.childCategories.findIndex(x => x.id == category.id);
        this.$refs.newCategoryAdd.rootCategory.childCategories[oldIndex] = this.$refs.newCategoryAdd.newCategory
      },
      addNewSubCategory(root) {
        this.$refs.newCategoryAdd.rootCategory = {
          id: root.id,
          name: root.name,
          childCategories: root.childCategories != null ? _.cloneDeep(root.childCategories) : [],
          rootCategoryId: root.rootCategoryId
        };
        this.$refs.newCategoryAdd.isActive = true;
        this.$refs.newCategoryAdd.newCategory = {
          id: null,
          imageUrl: null,
          index: 1,
          products: null,
          childCategories: null,
          rootCategoryId: root.id
        };
        this.$refs.newCategoryAdd.rootCategory.childCategories.push(this.$refs.newCategoryAdd.newCategory);
      },
      addNewCategory() {
        if (this.categoryBreadCrumbs.length > 1) {
          let root = this.categoryBreadCrumbs[this.categoryBreadCrumbs.length - 2];
          this.$refs.newCategoryAdd.rootCategory = {
            id: root.id,
            name: root.name,
            childCategories: _.cloneDeep(root.childCategories)
          }
        } else {
          let root = this.categories;
          this.$refs.newCategoryAdd.rootCategory = {
            id: 0,
            name: "Ana Kategori",
            childCategories: _.cloneDeep(root)
          }
        }
        this.$refs.newCategoryAdd.isActive = true;
        this.$refs.newCategoryAdd.newCategory = {
          id: null,
          imageUrl: null,
          index: 1,
          products: null,
          childCategories: null,
          rootCategoryId: this.categoryBreadCrumbs.length > 1 ? this.categoryBreadCrumbs[this.categoryBreadCrumbs
            .length - 2].id : null
        };
        this.$refs.newCategoryAdd.rootCategory.childCategories.push(this.$refs.newCategoryAdd.newCategory);
      },
      removeCategory(isRoot) {
        deleteProductCategory(this.toRemoveCategory.id).then(res => {
          if (res && res.status == 200) {
            this.$vs.notify({
              color: 'success',
              title: 'Başarılı !',
              text: 'Kategori Başarıyla Silindi !'
            });
            this.selectedCategory = null;
            if (isRoot == true) this.getBackCategory();
            let dataList = this.categoryBreadCrumbs.length > 0 ? this.categoryBreadCrumbs[this.categoryBreadCrumbs
              .length - 1].childCategories : this.categories;
            let index = dataList.findIndex(x => x.id == this.toRemoveCategory.id);
            dataList.splice(index, 1);
            this.deleteCategoryActive = false;
            this.toRemoveCategory = null;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kategori Silinemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      addNewProduct() {
        this.$refs.newProductAddToCategory.addNewProductActive = true;
        this.$refs.newProductAddToCategory.categoryId = this.selectedCategory.id;
      },
      saveNewCategory(root) {
        if (this.categoryBreadCrumbs.length > 1) {
          let oldRoot = this.categoryBreadCrumbs[this.categoryBreadCrumbs.length - 2];
          oldRoot = root.childCategories;
        } else {
          if (root.id != 0)
            this.goInsideCategory(root);
          else {
            this.categories = root.childCategories;
          }
        }
        this.selectedCategory = null;
      },
      getImage(image) {
        if (image == null) return this.$nullImage;
        else return this.$baseUrl + '/' + image;
      },
      getCategoryDetail(category) {
        getCategoryDetail(category.id).then(res => {
          if (res && res.status == 200) {
            if (res.data.products != null) {
              category.products = res.data.products;
              this.selectedCategory = category;
            } else if (res.data.childCategories != null) {
              category.childCategories = res.data.childCategories;
              this.goInsideCategory(category);
            } else {
              this.selectedCategory = category;
            }
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kategoriler Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
      getProductCategories() {
        getProductCategories().then(res => {
          if (res && res.status == 200) {
            this.categories = res.data;
          } else {
            this.$vs.notify({
              color: 'danger',
              title: 'Hata : ' + res.status,
              text: 'Kategoriler Yüklenemedi !'
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: 'danger',
            title: 'Hata !',
            text: 'Sunucu Bağlantı Hatası !'
          });
        });
      },
    },
    created() {
      this.getProductCategories();
    }
  }

</script>

<style>
  #productCategoryPage {
    overflow: hidden;
  }

  .activeCategory {
    color: rgba(var(--vs-dark), 1);
    font-weight: 500;
  }

  .passiveCategory {
    color: rgba(var(--vs-primary), 1);
    font-weight: bold;
  }

  .categoryRowImage {
    width: 48px;
    height: 48px;
    object-fit: cover;
    border-radius: 6px;
  }

  #categoryTable .selected-row,
  #productTable .selected-row {
    background-color: rgba(var(--vs-primary), .08);
  }

  .productListPopup .vs-popup {
    width: 70vw;
    max-width: 900px;
  }

  @media (max-width: 768px) {
    .productListPopup .vs-popup {
      width: 94vw;
    }
  }
</style>
